import { render } from "./App.vue?vue&type=template&id=794f1c1b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=794f1c1b&lang=scss"

import exportComponent from "C:\\Projects\\cram_srs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__